/**
 * @file routes/_app/settings/job-titles.tsx
 * @description 職稱字典維護頁。
 *
 * 此頁編輯的字典項會出現在「員工檔案 → 職稱」下拉選單。
 */

import { createFileRoute } from '@tanstack/react-router';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/job-titles')({
  component: JobTitlesPage,
});

/** 職稱維護頁 */
function JobTitlesPage() {
  return (
    <LookupAdminPage
      resource="job-titles"
      resourceLabel="職稱"
      description="維護「員工檔案 → 職稱」下拉選單的候選項（如董事長 / 總經理 / 管理者代表 / 軟體工程師）。"
      nameMaxLength={50}
    />
  );
}
